import { useEffect } from 'react';
import { Card, Row, Col } from "antd";
import { IView } from './types';

import config from '../config';
import LandingPageHeader from '../components/LandingPageHeader';
import { findIfExempt } from '../utils/findIfExempt';

const Landing: React.FunctionComponent<IView> = ({ user, logout }: IView) => {

    const handleOnestop1Click = (): void => {
        window.location.href = config.onestop1URL;
    };

    const handleOnestop2Click = (): void => {
        window.location.href = config.onestop2URL;
    };


    useEffect(() => {
        const script = document.createElement('script');
        const userid = user?.aer_id ?? 'none';
        const enableWalkMe = findIfExempt(userid);
        if (enableWalkMe) {
            // Load WalkMe script dynamically
            script.src = config.dapWalkMeURL;
            script.async = true;
            document.body.appendChild(script)
        }
        return () => {
            // Cleanup
            document.body.removeChild(script);
        };
    }, []);


    return (

        <div className='bgsso'>
            <LandingPageHeader user={user} logout={logout} />
            <Row gutter={0} className='rowC'>
                <Col span={1}></Col>
                <Col span={23}>
                    <table className='tableC'>
                        <tr className='trC'>
                            <td className='trWelcome'>
                                Welcome to OneStop
                            </td>

                        </tr>
                        <tr style={{ height: 8 }}>
                            <td >

                            </td>

                        </tr>
                        <tr className='trSelect'>
                            <td >
                                Select the pathway below.
                            </td>

                        </tr>
                    </table>

                </Col>
            </Row>
            <Row gutter={0} className='rowC2'>
                <Col span={1}></Col>
                <Col span={23}>

                    <table className='tableC'>
                        <tr className='trC'>
                            <td className='tdC1'>
                                <Card style={{ width: 370, height: 349 }}>
                                    <div className="sectionLPC">Services related to:</div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Wells</span></div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Pipelines</span></div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Public Lands</span></div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Reclamation</span></div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Water Approvals and Codes of Practice</span></div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Reporting and Forms</span></div>

                                    <br />
                                    <button id="onestop1" className="button" onClick={handleOnestop1Click}>CONTINUE</button>
                                </Card>
                            </td>
                            <td className='tdC2'>

                            </td>
                            <td className='tdC3'>
                                <Card style={{ width: 370, height: 349 }}>
                                    <span className="badge-new">NEW</span>
                                    <div className="sectionLPC">Services related to:</div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Water Licence Applications</span></div>
                                    <div className='listDivC'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;Water Submissions (Reporting)</span></div>
                                    <div className='listDivC2'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;D11 - Groundwater Protection</span></div>
                                    <div className='listDivC'><span className='listC'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Missing Information Form</span></div>
                                    <div className='listDivC2'><span className='checkC'>✓</span><span className='listC'>  &nbsp;&nbsp;D67 - Schedule 3</span></div>
                                    <div className='listDivC'><span className='listC'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Financial Statement Submission</span></div>
                                    <br />
                                    <span><button id="onestop2" className="button" onClick={handleOnestop2Click}>CONTINUE</button></span>
                                </Card>
                            </td>
                        </tr>
                    </table>

                </Col>
            </Row>


        </div >

    );
};

export default Landing;